<template>
    <div>
        <p>{{ answer }}</p>
    </div>
</template>

<script>
export default {
    name: "rate-question",
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        answer() {
            let answer = this.question.answer;
            return answer ?? "-";
        },
    },
};
</script>